import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  normalizeAnalyticsPath,
  trackAnalyticsControl,
  trackAppEvent,
} from "../../services/AppAnalytics";

const AppAnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackAppEvent("page_view", {
      page_path: normalizeAnalyticsPath(location.pathname),
    });
  }, [location.pathname]);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }

      const control = target.closest<HTMLElement>(
        "button, a, [role='button'], [role='menuitem']",
      );
      if (
        !control ||
        control.getAttribute("aria-disabled") === "true" ||
        control.hasAttribute("disabled")
      ) {
        return;
      }

      trackAnalyticsControl(control);
    };

    document.addEventListener("click", handleClick, { capture: true });
    return () =>
      document.removeEventListener("click", handleClick, { capture: true });
  }, []);

  return null;
};

export default AppAnalyticsTracker;
